import * as THREE from 'three';

export function normalizeModel(mesh) {
  const geometry = mesh.geometry;

  // Compute bounding box and center
  geometry.computeBoundingBox();
  const center = new THREE.Vector3();
  geometry.boundingBox.getCenter(center);

  // Center the geometry
  geometry.translate(-center.x, -center.y, -center.z);

  // Apply consistent orientation
  geometry.rotateX(-Math.PI / 2);
  geometry.rotateY(-Math.PI / 2);

  mesh.updateMatrixWorld(true);

  // Move mesh to rest on the ground
  const boundingBox = new THREE.Box3().setFromObject(mesh);
  mesh.position.y -= boundingBox.min.y;
  mesh.updateMatrix();
  mesh.updateMatrixWorld(true);
}
